import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const EyeIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.034 5.25049C4.53257 5.25049 1.53198 12.0018 1.53198 12.0018C1.53198 12.0018 4.53257 18.7531 12.034 18.7531C19.5355 18.7531 22.5361 12.0018 22.5361 12.0018C22.5361 12.0018 19.5355 5.25049 12.034 5.25049Z" stroke={color} strokeWidth="1.50029" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.0335 15.7524C14.1049 15.7524 15.7842 14.0732 15.7842 12.0017C15.7842 9.93024 14.1049 8.25098 12.0335 8.25098C9.96198 8.25098 8.28271 9.93024 8.28271 12.0017C8.28271 14.0732 9.96198 15.7524 12.0335 15.7524Z" stroke={color} strokeWidth="1.50029" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default memo(EyeIcon);
